<template>
    <header class="mg-header" :style="{ 'z-index': zIndex }">
        <a :href="`${host}/${path}/main/index.html`" class="mg-logo">
            <img class="logo" src="data:image/svg+xml;base64,PHN2ZyBpZD0i5Zu+5bGCXzEiIGRhdGEtbmFtZT0i5Zu+5bGCIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZpZXdCb3g9IjAgMCAxOSAxNyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJsaW5lYXItZ3JhZGllbnQiIHgxPSI2LjEzIiB5MT0iMy43IiB4Mj0iNy4wMiIgeTI9IjIuMTYiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiMwMGE2ZmQiLz48c3RvcCBvZmZzZXQ9IjAuNDQiIHN0b3AtY29sb3I9IiMyYTg3ZjAiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMwMGM3ZGIiLz48L2xpbmVhckdyYWRpZW50PjxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50LTIiIHgxPSI2LjgyIiB5MT0iMTQuODgiIHgyPSIxMy40NSIgeTI9IjMuNCIgeGxpbms6aHJlZj0iI2xpbmVhci1ncmFkaWVudCIvPjwvZGVmcz48dGl0bGU+bG9nb+WbvuaghzwvdGl0bGU+PHBhdGggZD0iTTUuNjEsMy44NGExLjMyLDEuMzIsMCwwLDEsMS4yNC40N3MwLS4xNywwLS4xNmExLjUyLDEuNTIsMCwwLDEsLjY4LTEuMDdjLjEtLjA3LjA2LS40NS4wNi0uNTRTNy41OCwyLDcuNTcsMmExLjg3LDEuODcsMCwwLDAtLjc2LDEuMzljMC0uMDUsMC0uMSwwLS4xNWExLjMsMS4zLDAsMCwwLTEuMjQtLjQ4Yy0uMTUsMCwwLDEuMDgsMCwxLjA4WiIgc3R5bGU9ImZpbGw6dXJsKCNsaW5lYXItZ3JhZGllbnQpIi8+PHBhdGggZD0iTTE1LjczLDEzSDUuMzNBMi4zOSwyLjM5LDAsMCwxLDMuNTQsMTJjLS44OC0xLjEzLS40Ny0yLjc2LDAtNCwuNjgtMS45LDEuOTMtMy4zMyw0LTMuMTVBNC4yMSw0LjIxLDAsMCwxLDExLDguOTFjLjA1LDIuMSwxLjU2LDQsMy43MiwzLjQ0YTQsNCwwLDAsMCwyLjQyLTIuODdBMy44MSwzLjgxLDAsMCwwLDE2LDYuMTFhMy45MSwzLjkxLDAsMCwwLTEuNjEtMWMtLjMzLS4xLS4yNC0uMTUtLjI3LS40OWEzLjM0LDMuMzQsMCwwLDAtLjI4LTEsMi43MywyLjczLDAsMCwwLTMuMjgtMS4zNEE0LjYyLDQuNjIsMCwwLDAsOC42NiwzLjg3Yy0uNDQuNDkuMzMtLjE4LjQ1LS4zMSwxLjExLTEuMjUsMy0uNDYsMy44Ni42MmEyLjgzLDIuODMsMCwwLDEsLjQ2LDEuNDdjMCwuMzEsMS4wOC42MiwxLjQyLjg1YTMuOTEsMy45MSwwLDAsMSwxLjYzLDMuMDgsMi42NCwyLjY0LDAsMCwxLS41NywxLjg2Yy0uMy4zMS0xLjI0LjI5LTEuNi4yNy0yLS4xNC0yLjM4LTIuNTYtMi42LTQuMThhNC4wOCw0LjA4LDAsMCwwLTQtMy40OGMtMy4yNCwwLTUuNzIsNC42Mi01LjQsNy41M0EyLjU2LDIuNTYsMCwwLDAsNSwxMy44SDE1Yy4yOSwwLC41Ny0uNzcuNzQtLjc3WiIgc3R5bGU9ImZpbGw6dXJsKCNsaW5lYXItZ3JhZGllbnQtMikiLz48L3N2Zz4=" data-image-src="./images/bk-logo.svg">
            <img class="logo-text" src="data:image/svg+xml;base64,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" data-image-src="./images/bk-text.svg">
            <strong>MagicBox</strong>
        </a>
        <div class="mg-header-right">
            <nav class="mg-nav" :style="{ 'border-right': region !== 'tencent' ? '1px solid #373839' : 'none' }">
                <ul>
                    <li class="nav-item">
                        <a href="javascript: void(0);">组件库</a>
                        <div class="mg-sub-nav">
                            <ol>
                                <dt>PC端</dt>
                                <dd>
                                    <a href="https://magicbox.bk.tencent.com/magicbox/3.0/">Vue3 组件</a>
                                </dd>
                                <dd>
                                    <a :href="`${host}/${path}/components_vue/2.0/example/index.html`" :data-active="`/components_vue/\\S+?/`">Vue2 组件</a>
                                </dd>
                                <dd>
                                    <a :href="`${host}/${path}/index.html`" :data-active="`${host}/${path}/index.html#detail/show\\?id=\\S+?&isPro=0`">jQuery组件1.0</a>
                                </dd>
                                <dd>
                                    <a :href="`${host}/${path}/index.html#index?isPro=1`" :data-active="`${host}/${path}/index.html#detail/show\\?id=\\S+?&isPro=1`">jQuery组件2.0</a>
                                </dd>
                            </ol>
                            <ol>
                                <dt>移动端</dt>
                                <dd>
                                    <a :href="`${host}/${path}/index.html#mobile/show`" :data-active="`${host}/${path}/index.html#mobile_detail/show\\?id=\\S+?`">jQuery组件</a>
                                </dd>
                                <dd>
                                    <a target="_blank" href="https://developers.weixin.qq.com/miniprogram/dev/component/">微信小程序官方组件</a>
                                </dd>
                            </ol>
                        </div>
                    </li>
                    <li class="nav-item">
                        <a href="javascript: void(0);">运维开发</a>
                        <div class="mg-sub-nav">
                            <ol>
                                <dt>PC端</dt>
                                <dd>
                                    <!-- <a :href="`${host}/${path}/index.html#build/show`" target="_blank">jQuery组件</a> -->
                                    <a href="javascript: void(0);" @click="() => void linkTo(`${host || locationOrigin}/${path}/index.html#build/show`)">jQuery组件</a>
                                </dd>
                                <dd v-if="lessCodeUrl">
                                    <a :href="lessCodeUrl" target="_blank">Vue组件</a>
                                </dd>
                            </ol>
                            <ol>
                                <dt>移动端</dt>
                                <dd>
                                    <!-- <a :href="`${host}/${path}/index.html#mobile_build/show`" target="_blank">jQuery组件</a> -->
                                    <a href="javascript: void(0);" @click="() => void linkTo(`${host || locationOrigin}/${path}/index.html#mobile_build/show`)">jQuery组件</a>
                                </dd>
                                <!-- <dd v-if="region === 'tencent'">
                                    <a :href="`${host}/#wx_build/show`">微信小程序</a>
                                </dd>
                                <dd v-else>
                                    <a href="https://magicbox.bk.tencent.com/static_api/v3/index.html#wx_build/show" target="_blank">微信小程序</a>
                                </dd> -->
                                <dd>
                                    <!-- <a href="https://magicbox.bk.tencent.com/static_api/v3/index.html#wx_build/show" target="_blank">微信小程序</a> -->
                                    <a href="javascript: void(0);" @click="() => void linkTo('https://magicbox.bk.tencent.com/static_api/v3/index.html#wx_build/show')">微信小程序</a>
                                </dd>
                            </ol>
                        </div>
                    </li>
                    <li class="nav-item" v-if="region === 'tencent'">
                        <a target="_blank" href="https://bkcharts.bk.tencent.com">BKCharts</a>
                    </li>
                    <li class="nav-item">
                        <a :href="`${host}/${path}/index.html#templates`">套餐样例</a>
                    </li>
                    <!-- <li class="nav-item">
                        <a href="javascript: void(0);">帮助</a>
                        <div class="mg-sub-nav">
                            <ol>
                                <dt>规范</dt>
                                <dd>
                                    <a href="https://bk.tencent.com/docs/document/5.1/219/15207" target="_blank">前端规范</a>
                                </dd>
                                <dd>
                                    <a :href="designUrl" v-if="designUrl">设计规范</a>
                                    <a :href="`${host}/${path}/index.html#design`" v-else>设计规范</a>
                                </dd>
                                <dd>
                                    <a :href="`${host}/${path}/index.html#css`">辅助样式</a>
                                </dd>
                            </ol>
                            <ol>
                                <dt>下载</dt>
                                <dd>
                                    <a :href="`${host}/${path}/index.html#about/show`">模板下载</a>
                                </dd>
                                <dd>
                                    <a :href="`${host}/${path}/index.html#plugin`">组件包下载</a>
                                </dd>
                                <dd v-if="designUrl">
                                    <a :href="`${designUrl}/resource`">sketch组件包</a>
                                </dd>
                            </ol>
                        </div>
                    </li> -->
                    <li class="nav-item">
                        <a href="javascript: void(0);">规范</a>
                        <div class="mg-sub-nav spec">
                            <ol>
                                <dd>
                                    <a href="https://bk.tencent.com/docs/document/5.1/219/15207" target="_blank">前端规范</a>
                                </dd>
                                <dd>
                                    <a :href="designUrl" v-if="designUrl">设计规范</a>
                                    <a :href="`${host}/${path}/index.html#design`" v-else>设计规范</a>
                                </dd>
                                <dd>
                                    <a :href="`${host}/${path}/index.html#css`">辅助样式</a>
                                </dd>
                            </ol>
                        </div>
                    </li>
                    <li class="nav-item">
                        <a href="javascript: void(0);">下载</a>
                        <div class="mg-sub-nav download">
                            <ol>
                                <dd>
                                    <a :href="`${host}/${path}/index.html#about/show`">模板下载</a>
                                </dd>
                                <dd>
                                    <a :href="`${host}/${path}/index.html#plugin`">组件包下载</a>
                                </dd>
                                <dd v-if="designUrl">
                                    <a :href="`${designUrl}/resource`">sketch组件包</a>
                                </dd>
                            </ol>
                        </div>
                    </li>

                    <li class="nav-item">
                        <a :href="`${host}/${path}/index.html#start`">新手起步</a>
                    </li>
                    <li class="nav-item" v-if="region !== 'tencent'">
                        <a href="javascript: void(0);" style="position: relative;">
                            更多
                            <img class="new-logo" src="data:image/svg+xml;base64,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" data-image-src="./images/new.svg">
                        </a>
                        <div class="mg-sub-nav more">
                            <ol>
                                <dd>
                                    <a :href="`http://bkicon.${rootDomain}/`">IconCool</a>
                                </dd>
                                <dd>
                                    <a :href="`http://bkflow.${rootDomain}/`">BKFlow</a>
                                </dd>
                                <dd>
                                    <a href="https://bkcharts.bk.tencent.com">BKCharts</a>
                                </dd>
                                <dd>
                                    <a :href="`https://bkcontent.w${rootDomain}/`">内容市场</a>
                                </dd>
                            </ol>
                        </div>
                    </li>
                    <li v-else>
                        <a href="https://bk.tencent.com/s-mart/community/search?searchText=magicbox" target="_blank">论坛交流</a>
                    </li>
                </ul>
            </nav>

            <!-- 外部版不登录 -->
            <template v-if="region !== 'tencent'">
                <template v-if="userName">
                    <div class="mg-user" id="mg-user">
                        <img :src="avatar" class="avatar" id="mg-avatar"/>
                        <strong class="name" id="mg-name">{{userName}}</strong>
                    </div>
                    <a href="javascript: void(0);" class="mg-login" @click="goLogin">退出</a>
                </template>
                <template v-else>
                    <a href="javascript: void(0);" class="mg-login" @click="goLogin">登录</a>
                </template>
            </template>
        </div>

        <div class="magic-button">
            <a href="javascript:;" class="magic-top" id="mg-top" @click="handleGoTop" style="opacity: 0;">
                <img src="./images/back_top.png" data-image-src="./images/back_top.png">
            </a>
            <a href="http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDgwMjAwMV80NDMwOTZfODAwODAyMDAxXzJf" target="_blank" class="magic-feedback" title="蓝鲸MagicBox助手" v-if="region === 'tencent'">
                <img src="./images/feedback.png" data-image-src="./images/feedback.png">
            </a>
            <a href="wxwork://message/?username=BK-MagicBox" class="magic-feedback" title="蓝鲸MagicBox助手" v-else>
                <img src="./images/feedback.png" data-image-src="./images/feedback.png">
            </a>
        </div>
    </header>
</template>

<script type="text/javascript">
    import cookie from './js.cookie.mjs';

    async function loadImage(url) {
        return new Promise((resolve, reject) => {
            var i = new Image()
            i.onload = () => resolve(i)
            i.onerror = reject
            i.src = url
        })
    }

    export default {
        name: 'magicbox-header',
        props: {
            host: {
                type: String,
                default: ''
            },
            env: {
                type: String,
                default: 'prod'
            },
            rootDomain: {
                type: String,
                default: ''
            },
            region: {
                type: String,
                default: 'tencent'
            },
            loginUrl: {
                type: String,
                default: ''
            },
            avatarUrl: {
                type: String,
                default: ''
            },
            avatarHost: {
                type: String,
                default: ''
            },
            avatarNewHost: {
                type: String,
                default: ''
            },
            lessCodeUrl: {
                type: String,
                default: ''
            },
            designUrl: {
                type: String,
                default: ''
            },
            zIndex: {
                type: Number,
                default: 1000
            },
            feDocUrl: {
                type: String,
                default: ''
            }
        },
        data () {
            return {
                userName: '',
                avatar: '',
                isTop: true,
                timer: 0,
                mainDomain: ''
            }
        },
        computed: {
            bkTicket () {
                return this.region === 'tencent' ? 'p_uin' : 'bk_uid'
            },
            appCode () {
                return this.region === 'tencent' ? 'ui-bk' : 'MagicBox'
            },
            path () {
                return this.env === 'prod' ? 'static_api/v3' : 'static/v3'
            },
            locationOrigin () {
                return window.location.origin
            }
        },
        mounted () {
            window.cookie = cookie
            this.init()
        },
        beforeDestroy () {
            window.removeEventListener('popstate', this.popstateListener)
            window.removeEventListener('hashchange', this.hashchangeListener, false)
        },
        methods: {
            linkTo (url) {
                // 内部版在打开页面时就跳转到登录了
                if (this.region === 'tencent') {
                    const ticket = cookie.get(this.bkTicket)
                    if (!ticket) {
                        this.goLogin(url)
                        return
                    }
                }
                setTimeout(() => {
                    window.open(url)
                }, 0)
            },
            // 登录
            goLogin (cUrl = location.href) {
                // 当前不是所属域名打开
                if (location.host.indexOf(this.rootDomain) === -1) {
                    return false
                }
                const loginUrl = `${this.loginUrl}?app_code=${this.appCode}&c_url=${encodeURIComponent(cUrl)}`
                if (window.bk_logout) {
                    window.bk_logout.logout(function () {
                        location.href = loginUrl
                    })
                } else {
                    cookie.remove(this.bkTicket, {
                        domain: this.mainDomain,
                        path: '/'
                    })
                    location.href = loginUrl
                }
            },

            //初始化底部工具（反馈、回到头部）
            initFootTools () {
                const topBtn = document.getElementById('mg-top')
                this.isTop = true
                //获取页面的可视窗口高度
                let client_height = document.documentElement.clientHeight || document.body.clientHeight
                //滚动条滚动时触发
                window.onscroll = function(){
                    //在滚动的时候增加判断,忘了的话很容易出错
                    const osTop = document.documentElement.scrollTop || document.body.scrollTop
                    if (osTop >= 200) {
                        topBtn.style.opacity = '1'
                    } else {
                        topBtn.style.opacity = '0'
                    }
                    if(!this.isTop){
                        clearInterval(this.timer)
                    }
                    this.isTop = false
                }
            },

            handleGoTop () {
                this.isTop = false
                clearInterval(this.timer)
                this.timer = setInterval(() => {
                    const osTop = document.documentElement.scrollTop || document.body.scrollTop
                    //减小的速度
                    const isSpeed = Math.floor(-osTop / 6)
                    document.documentElement.scrollTop = document.body.scrollTop = osTop + isSpeed
                    //判断，然后清除定时器
                    if (osTop < 200) {
                        console.log('clear')
                        clearInterval(this.timer)
                    }
                    this.isTop = true
                }, 30)
            },

            // 设置用户信息
            setUserInfo (avatar, userName) {
                this.userName = userName
                this.avatar = avatar
            },

            // 初始化
            init () {
                // 外部版不登录
                if (this.region === 'tencent') {
                    return
                }
                const ticket = cookie.get(this.bkTicket)

                if (!ticket) {
                    this.goLogin()
                } else {
                    let userName = ''
                    let avatar = ''
                    if (this.region === 'tencent') {
                        userName = parseInt(ticket.slice(1, ticket.length))
                        avatar = `${this.avatarHost}/g?b=qq&nk=${userName}&s=100&t=1480074562.7`
                        this.setUserInfo(avatar, userName)
                    } else {
                        userName = ticket
                        if (this.avatarNewHost) {
                            avatar = `${this.avatarNewHost}/photo/500/${ticket}.png`
                            loadImage(avatar).then(ret => {
                                avatar = ret.src
                            }).catch(e => {
                                avatar = 'data:image/gif;base64,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'
                            }).finally(() => {
                                this.setUserInfo(avatar, userName)
                            })
                        } else {
                            avatar = `${this.avatarHost}/avatars/${ticket}/avatar.jpg`
                            this.setUserInfo(avatar, userName)
                        }
                    }
                }

                const reg = this.region === 'tencent' ? /\w*.\w*\.(com|cn)$/ : /\w*\.(com|cn)$/
                const matcher = location.hostname.match(reg)
                this.mainDomain = matcher ? matcher[0] : ''

                this.initFootTools()
                this.initNavActive()
            },

            handleFeedback () {
                try {
                    document.getElementById('contact_us').click()
                } catch (e) {
                    console.warn(e)
                }
            },

            initNavActive () {
                window.addEventListener('popstate', this.popstateListener)
                window.addEventListener('hashchange', this.hashchangeListener, false)
                this.handleNavActive()
            },
            popstateListener (event) {
                this.handleNavActive()
            },
            hashchangeListener () {
                this.handleNavActive()
            },
            handleNavActive () {
                const navEl = document.querySelector('.mg-nav')
                if (!navEl) {
                    return
                }
                const allLinks = document.querySelector('.mg-nav').querySelectorAll('a')
                const linkList = Array.from(allLinks)
                linkList.forEach(a => {
                    a.classList.remove('active')
                    let href = location.href.replace(/#(\/)/, '#')
                    if (href.endsWith('#')) {
                        href = href.substring(0, href.length - 1)
                    }
                    let regMatched = false
                    if (a.dataset.active) {
                        const reg = new RegExp(a.dataset.active)
                        regMatched = reg.test(href)
                    }
                    if (location.href === a.href || href === a.href || regMatched) {
                        const parentNav = a.closest('.nav-item')
                        if (parentNav) {
                            parentNav.classList.add('active')
                        }
                        a.classList.add('active')
                    }
                })
            }
        }
    }
</script>

<style scoped>
    html,body,div,p,ul,li,h1,h2,h3 {
        padding:0;
        margin:0;
    }
    strong {
        font-weight:normal;
    }
    a {
        text-decoration:none;
    }
    img {
        vertical-align:middle;
    }
    * {
        box-sizing:border-box;
        outline:none;
    }
    .fl {
        float:left;
    }
    .fr {
        float:right;
    }
    .f16 {
        font-size:16px;
    }
    .f14 {
        font-size:14px;
    }
    .f13 {
        font-size:13px;
    }
    .f12 {
        font-size:12px;
    }
    .hide {
        display:none;
    }
    .show {
        display:block;
    }
    .mg-header {
        width:100%;
        min-width:1280px;
        height:64px;
        background:#14182F;
        color:#FFF;
        padding:0 32px;
        z-index:1000;
        position:fixed;
        top:0;
    }
    .mg-header .mg-header-right {
        float:right;
    }
    .mg-logo {
        float:left;
        height:64px;
        color:#FFF;
        font-size:18px;
        padding-top:10px;
    }
    .mg-logo .logo {
        vertical-align:middle;
        height:44px;
        margin-right:2px;
    }
    .mg-logo .logo-text {
        vertical-align:middle;
        height:32px;
        margin-right:15px;
    }
    .mg-logo strong {
        vertical-align:middle;
        line-height:31px;
        border-left:1px solid rgba(255,255,255,0.3);
        padding-left:15px;
        color:#FFF;
    }
    .mg-nav {
        float:left;
        margin:20px 0 0 0;
    }
    .mg-nav > ul {
        list-style:none;
        float:right;
    }
    .mg-nav > ul::after {
        content:'';
        display:inline-block;
        clear:both;
    }
    .mg-nav > ul li {
        float:left;
        padding:0 24px;
        position:relative;
    }
    .mg-nav > ul li:hover .mg-sub-nav {
        display:flex;
    }
    .mg-nav > ul li:hover > a {
        color:#4F94FE;
    }
    .mg-nav > ul li.active > a {
        color:#4F94FE;
    }
    .mg-nav > ul li.active::after {
        content:'';
        position:absolute;
        left:0;
        top:40px;
        width:calc(100% - 44px);
        height:4px;
        margin-left:22px;
        background:#4F94FE;
    }
    .mg-nav > ul li.active:hover::after {
        display:none;
    }
    .mg-nav > ul a {
        color:#FFF;
        line-height:14px;
        text-decoration:none;
        font-size:14px;
        transition:color ease 0.3s;
    }
    .mg-nav > ul a:hover,.mg-nav > ul a.active {
        color:#4F94FE;
    }
    .mg-nav .mg-sub-nav {
        width:310px;
        background:#14182F;
        position:absolute;
        padding:25px;
        justify-content:space-between;
        display:none;
        left:50%;
        transform:translateX(-50%);
        border-radius:4px;
        opacity:0;
        animation:fadeIn forwards ease 0.5s;
        color:#C4C6CC;
    }
    .mg-nav .mg-sub-nav.spec {
        width: 100px;
        padding-left: 21px;
    }
    .mg-nav .mg-sub-nav.spec > ol {
        min-width: 60px;
    }
    .mg-nav .mg-sub-nav.download {
        width: 120px;
        padding-left: 20px;
    }
    .mg-nav .mg-sub-nav.download > ol {
        min-width: 90px;
    }
    .mg-nav .mg-sub-nav > ol {
        min-width:110px;
        float:left;
        padding:0;
        margin:15px 0 0;
    }
    .mg-nav .mg-sub-nav > ol dt {
        font-size:14px;
        padding-bottom:10px;
        border-bottom:1px solid rgba(255,255,255,0.3);
        margin-bottom:8px;
    }
    .mg-nav .mg-sub-nav > ol dd {
        color:#FFF;
        font-size:12px;
        line-height:30px;
        padding:0;
        margin:0;
        text-align:left;
    }
    .mg-nav .mg-sub-nav > ol dd > a {
        line-height:30px;
    }
    .mg-nav .mg-sub-nav > ol dd > span {
        font-size:14px;
        color:#ccc;
    }
    .mg-nav .mg-sub-nav.more {
        width:auto;
        padding:18px;
    }
    .mg-nav .mg-sub-nav.more > ol {
        min-width:86px;
    }
    .mg-user {
        min-width:100px;
        float:left;
        margin:19px 0 0 0;
        padding-left:24px;
        font-size:14px;
        color:#FFF;
    }
    .mg-user .avatar {
        width:28px;
        height:28px;
        border-radius:50%;
        vertical-align:middle;
        margin-right:5px;
    }
    .mg-login {
        float:left;
        line-height:28px;
        margin: 17px 0 0 24px;
        font-size:14px;
        color:#FFF;
    }
    .mg-login:hover {
        color:#FFF;
    }
    .magic-button {
        position:fixed;
        right:10px;
        bottom:50px;
    }
    .magic-button a {
        display:block;
        width:30px;
        height:30px;
        line-height:26px;
        text-align:center;
        background:#9a9a9a;
        border-radius:2px;
        opacity:0.7;
    }
    .magic-button a:hover {
        background:#454545;
    }
    .magic-button a > img {
        width:16px;
    }
    .magic-button .magic-feedback {
        margin-top:5px;
    }
    .mg-nav .new-logo {
        width: 14px;
        height: auto;
        position: absolute;
        top: -6px;
        right: -16px;
    }
    @media screen and (max-width:1980px) {
        body {
            background-size:55% auto;
        }
    }
    @media screen and (max-width:1680px) {
        .my-components {
            margin-bottom:50px;
        }
    }
    @media screen and (max-width:1280px) {
        .mg-user,.mg-login,.mg-nav > ul a,.mg-nav .mg-sub-nav > ol dt {
            font-size:12px;
        }
        .mg-nav > ul a,.mg-nav .mg-sub-nav > ol dd > span {
            font-size:12px;
        }
        .mg-nav .mg-sub-nav {
            padding:15px 25px;
        }
    }
    @keyframes expand {
        from {
            width:10%;
        }
        to {
            width:100%;
        }
        }@keyframes fadeIn {
            from {
            opacity:0;
        }
        to {
            opacity:1;
        }
    }
    @keyframes fadeInDown {
        0% {
            top:-20px;
            opacity:0;
        }
        100% {
            top:5px;
            opacity:1;
        }
    }
    @keyframes fadeOutDown {
        0% {
            top:10px;
            opacity:1;
        }
        5% {
            opacity:0.2;
        }
        100% {
            top:100px;
            opacity:0;
        }
    }
</style>
